import React, { useCallback, useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { pick, isNil } from "ramda";

import {
  getSelectedPreparedStops,
  getStopFilters,
} from "../../store/selectors/ui/routeDetail";
import { getRouteDetail } from "../../store/selectors/route";
import SelectByCriteriaModal from "../../components/modals/SelectByCriteria/SelectByCriteriaModal";
import * as routeDetailActions from "../../store/actions/ui/routeDetail";

const SelectByCriteriaModalContainer = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const selectedStops = useSelector(getSelectedPreparedStops);
  const route = useSelector(getRouteDetail);
  const { criteria } = useSelector(getStopFilters);
  const { setCriteria, resetSelectedParcels } = useMemo(
    () =>
      bindActionCreators(
        pick(["resetSelectedParcels", "setCriteria"], routeDetailActions),
        dispatch
      ),
    [dispatch]
  );

  const [changed, setChanged] = useState(false);

  useEffect(() => {
    if ((selectedStops.length || !criteria.length) && changed) {
      onClose();
    }
  }, [changed, criteria, onClose, selectedStops]);

  const handleSaveClick = useCallback(
    ({ criteria }) => {
      const nonEmptyCriteria = criteria.filter(({ value }) => !isNil(value));

      resetSelectedParcels();
      setCriteria(nonEmptyCriteria);
      setChanged(true);
    },
    [resetSelectedParcels, setCriteria]
  );

  return (
    <SelectByCriteriaModal
      onSave={handleSaveClick}
      open={open}
      onClose={onClose}
      route={route}
      criteria={criteria}
    />
  );
};

export default SelectByCriteriaModalContainer;
